import { ApolloClient, ApolloProvider, HttpLink, InMemoryCache, NormalizedCacheObject } from "@apollo/client";
import React from "react";
import { useSelector } from "react-redux";
import config from "../config";
import { IRootReducer } from "../redux/reducers";
import { getHasAccess } from "../redux/selectors/auth.selectors";
import { persistCache } from "apollo-cache-persist";
import { PersistentStorage, PersistedData } from "apollo-cache-persist/types";
import createUploadLink from "apollo-upload-client/public/createUploadLink.js";

const cache = new InMemoryCache();

persistCache({
  cache,
  storage: window.localStorage as PersistentStorage<PersistedData<NormalizedCacheObject>>,
});

const client = new ApolloClient({ 
  cache,
  credentials: "include",
});
export const apolloClient = client; 

type ApolloClientProviderProps = { children: React.ReactChild };

const ApolloClientProvider: React.FC<ApolloClientProviderProps> = ({ children }) => {
    const state = useSelector((state:IRootReducer) => state);
    // TODO: Utilize this?
    const hasAccess = getHasAccess(state);
    
    const link = createUploadLink({
      uri: `${config.api.url}/graphql`,
      credentials: "include",
      headers: {
        "apollo-require-preflight": true
      }
    })

    client.setLink(link);
  
    return (
      <ApolloProvider client={client}>
        { children }
      </ApolloProvider>
    )
}

export default ApolloClientProvider; 